/*@ngInject*/
const UpdateChecklistItemRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.updateChecklistItem = function (checklistItemId, checked, comment) {
        let url = '/rest/UnderwritingCheckListItem/' + checklistItemId,
            config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            },
            payload = 'checked=' + checked;

        if (!comment) {
            comment = '';
        }

        payload += '&comment=' + encodeURIComponent(comment);

        return this.post(url, payload, config);
    };
};

angular.module('gw-um-submission')
    .service('updateChecklistItemRepository', UpdateChecklistItemRepository);
